<template>
  <v-container fluid class="pa-4" style="background-color: #f5f5f5;"> 
    <v-form ref="profileForm" lazy-validation>
    <v-row>
      <!-- 1. Personal Details -->
      <v-col cols="12" md="6">
        <v-card class="pa-6 rounded-xl h-100" elevation="2">
          <div class="d-flex align-center mb-5 pb-2" style="border-bottom: 2px solid #e8f5e9;">
            <v-avatar color="#e8f5e9" size="40" class="mr-3">
              <v-icon color="#005f32">mdi-card-account-details-outline</v-icon>
            </v-avatar>
            <div class="text-h6 font-weight-bold" style="color: #005f32;">1. Personal Details</div>
          </div>
          <v-row>
            <v-col cols="12" sm="3" class="d-flex flex-column align-center justify-start pt-1 mt-n1">
              <v-avatar size="100" color="#F5F5F5" class="elevation-1" style="cursor: pointer; border: 1px solid #E0E0E0;" @click="$refs.photo.click()">
                <img v-if="formData.photoPreview" :src="formData.photoPreview" alt="Profile Photo" style="object-fit: cover;">
                <div v-else class="d-flex flex-column align-center justify-center w-100 h-100" style="position: relative;">
                  <v-icon size="45" color="#9E9E9E" style="margin-top: -12px;">mdi-account</v-icon>
                  <span style="position: absolute; bottom: 8px; font-size: 10px; font-weight: 600; color: #757575; text-align: center; line-height: 1.2;">Upload<br>Image</span>
                </div>
              </v-avatar>
              <input v-show="false" ref="photo" type="file" accept="image/*" @change="onImageSelected" />
            </v-col>
            <v-col cols="12" sm="9">
              <v-row>
                <v-col cols="4" class="py-1">
                  <v-text-field label="Title" v-model="formData.title" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="4" class="py-1">
                  <v-text-field label="First Name" v-model="formData.firstName" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="4" class="py-1">
                  <v-text-field label="Last Name" v-model="formData.lastName" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" sm="6" class="py-1">
                  <v-text-field label="Father's Name" v-model="formData.fathersName" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-1">
                  <v-text-field label="Mother's Name" v-model="formData.mothersName" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="py-1">
              <v-menu v-model="menuDob" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field label="Date of Birth" v-model="formData.dob" outlined dense hide-details readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="formData.dob" no-title @input="menuDob = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field label="Place of Birth" v-model="formData.placeOfBirth" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="py-1">
              <v-select label="Gender" v-model="formData.gender" :items="['Male', 'Female', 'Other']" outlined dense hide-details></v-select>
            </v-col>
            <v-col cols="12" sm="4" class="py-1">
              <v-select label="Blood Group" v-model="formData.bloodGroup" :items="['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']" outlined dense hide-details></v-select>
            </v-col>
            <v-col cols="12" sm="4" class="py-1">
              <v-text-field label="Nationality" v-model="formData.nationality" outlined dense hide-details></v-text-field>
            </v-col>
            
            <v-col cols="12" class="py-1 mt-2">
              <div class="caption font-weight-bold">Contact Details</div>
            </v-col>
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field label="Contact Number" v-model="formData.mobileNo" :rules="[rules.phone]" outlined dense hide-details="auto" prepend-inner-icon="mdi-phone"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field label="Email ID" v-model="formData.emailId" :rules="[rules.email]" outlined dense hide-details="auto" prepend-inner-icon="mdi-email"></v-text-field>
            </v-col>
            <v-col cols="12" class="py-1">
              <v-textarea label="Mailing Address" v-model="formData.mailingAddress" outlined dense hide-details="auto" rows="2"></v-textarea>
            </v-col>
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field label="PIN (Mailing)" v-model="formData.mailingPin" :rules="[rules.pin]" outlined dense hide-details="auto"></v-text-field>
            </v-col>
            
            <v-col cols="12" class="py-1 mt-2">
              <v-checkbox v-model="sameAsMailing" label="Permanent Address same as Mailing" hide-details class="mt-0 pt-0"></v-checkbox>
            </v-col>
            <v-col cols="12" class="py-1">
              <v-textarea label="Permanent Address" v-model="formData.permanentAddress" :readonly="sameAsMailing" outlined dense hide-details="auto" rows="2"></v-textarea>
            </v-col>
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field label="PIN (Permanent)" v-model="formData.permanentPin" :readonly="sameAsMailing" :rules="[rules.pin]" outlined dense hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- 2. KYC Details -->
      <v-col cols="12" md="6">
        <v-card class="pa-6 rounded-xl h-100" elevation="2">
          <div class="d-flex align-center mb-5 pb-2" style="border-bottom: 2px solid #e8f5e9;">
            <v-avatar color="#e8f5e9" size="40" class="mr-3">
              <v-icon color="#005f32">mdi-shield-check</v-icon>
            </v-avatar>
            <div class="text-h6 font-weight-bold" style="color: #005f32;">2. KYC Details</div>
          </div>
          <v-row>
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field label="PAN Number" v-model="formData.panCardNum" :rules="[rules.pan]" outlined dense hide-details="auto" prepend-inner-icon="mdi-card-account-details"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field label="Aadhaar Number" v-model="formData.adharCardNum" :rules="[rules.aadhaar]" outlined dense hide-details="auto" prepend-inner-icon="mdi-card-account-details-outline"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field label="Passport Number" v-model="formData.passportNumber" outlined dense hide-details="auto"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field label="Driving License No." v-model="formData.drivingLicense" outlined dense hide-details="auto"></v-text-field>
            </v-col>
            
            <v-col cols="12" class="pt-4 pb-0">
              <div class="caption font-weight-bold">Bank Account Details</div>
            </v-col>
            <v-col cols="12" sm="4" class="py-1">
              <v-text-field label="Bank Name" v-model="formData.bankName" outlined dense hide-details="auto"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="py-1">
              <v-text-field label="Account Number" v-model="formData.acNum" :rules="[rules.accountNumber]" outlined dense hide-details="auto"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="py-1">
              <v-text-field label="IFSC Code" v-model="formData.ifsc" :rules="[rules.ifsc]" outlined dense hide-details="auto"></v-text-field>
            </v-col>
            
            <v-col cols="12" sm="12" class="py-1 mt-3">
              <v-text-field label="EPF UAN Number" v-model="formData.epfUan" :rules="[rules.uan]" outlined dense hide-details="auto" prepend-inner-icon="mdi-lock-outline"></v-text-field>
              <div class="text-center mt-1">
                <a href="/EPFO UAN Allotment.pdf" target="_blank" style="font-size: 12px; font-weight: 600; color: #005f32 !important; text-decoration: underline;">Don't have a UAN number? Click here for generation guide</a>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-center py-0 mt-2">
              <v-checkbox v-model="formData.isNewEmployee" label="New Employee" color="#005f32" class="mr-6 mt-0" hide-details @change="formData.isExistingEmployee = !formData.isNewEmployee"></v-checkbox>
              <v-checkbox v-model="formData.isExistingEmployee" label="Existing Employee" color="#005f32" class="mt-0" hide-details @change="formData.isNewEmployee = !formData.isExistingEmployee"></v-checkbox>
            </v-col>
          </v-row>
          
          <div v-if="formData.isNewEmployee">
            <v-divider class="mt-6 mb-4"></v-divider>
            <div class="subtitle-1 font-weight-bold mb-3 text-center" style="color: #005f32;">Upload Documents</div>
            <p class="caption mb-2 text-left pl-1"><b>Please upload these necessary documents here:</b></p>
            <div class="d-flex justify-start mb-4">
              <ul class="caption font-weight-bold text-left pl-6" style="max-width: 600px; line-height: 1.6;">
                <li>Aadhar Card</li>
                <li>PAN Card</li>
                <li>10th Class Marksheet (DMC)</li>
                <li>Recent passport-size photograph</li>
                <li>Bank details (first page of passbook or a cancelled cheque)</li>
                <li>Blood group information</li>
                <li>Highest degree certificate</li>
                <li>Last salary slip</li>
                <li>Experience letter</li>
              </ul>
            </div>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field label="Document Title" v-model="docUploadData.title" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="5">
                <v-file-input label="Select File" v-model="docUploadData.file" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" outlined dense hide-details prepend-icon="" prepend-inner-icon="mdi-paperclip"></v-file-input>
              </v-col>
              <v-col cols="12" sm="3">
                <v-btn color="#005f32" dark class="text-capitalize" @click="uploadEmployeeDocument" :loading="isDocUploading" style="width: 100%; height: 40px;">
                  <v-icon left size="20">mdi-cloud-upload</v-icon> Upload
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- 3. Family Details -->
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card class="pa-6 rounded-xl" elevation="2">
          <div class="d-flex align-center mb-5 pb-2" style="border-bottom: 2px solid #e8f5e9;">
            <v-avatar color="#e8f5e9" size="40" class="mr-3">
              <v-icon color="#005f32">mdi-home-heart</v-icon>
            </v-avatar>
            <div class="text-h6 font-weight-bold" style="color: #005f32;">3. Family Details</div>
          </div>
          <v-row>
            <v-col cols="12" sm="3" class="py-1">
              <v-select label="Marital Status" v-model="formData.maritalStatus" :items="['Married', 'Unmarried', 'Widow', 'Widower', 'Divorcee']" outlined dense hide-details></v-select>
            </v-col>
            <v-col cols="12" sm="3" class="py-1" v-if="formData.maritalStatus === 'Married'">
              <v-menu v-model="menuDom" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field label="Date of Marriage" v-model="formData.dateOfMarriage" outlined dense hide-details readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="formData.dateOfMarriage" no-title @input="menuDom = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <div v-if="formData.maritalStatus === 'Married'" class="mt-4">
            <div class="caption font-weight-bold mb-2">Spouse Details</div>
            <v-row>
              <v-col cols="12" sm="3" class="py-1">
                <v-text-field label="Name of Spouse" v-model="formData.spouseName" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="py-1">
                <v-text-field label="Occupation" v-model="formData.spouseOccupation" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <v-text-field label="If working, organization name & address" v-model="formData.spouseOrganization" outlined dense hide-details></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div class="mt-4">
            <div class="d-flex justify-space-between align-center mb-2">
              <div class="caption font-weight-bold">Children Details</div>
              <v-btn small color="#005f32" dark @click="addChildRow">
                <v-icon left>mdi-plus</v-icon> Add Child
              </v-btn>
            </div>
            <v-data-table
              :headers="childHeaders"
              :items="formData.children"
              hide-default-footer
              class="elevation-0"
              dense
            >
              <template v-slot:item.name="{ item }">
                <v-text-field v-model="item.name" dense hide-details></v-text-field>
              </template>
              <template v-slot:item.gender="{ item }">
                <v-select v-model="item.gender" :items="['Male', 'Female', 'Other']" dense hide-details></v-select>
              </template>
              <template v-slot:item.age="{ item }">
                <v-text-field v-model="item.age" type="number" dense hide-details></v-text-field>
              </template>
              <template v-slot:item.actions="{ item, index }">
                <v-icon color="red" @click="removeChildRow(index)">mdi-delete</v-icon>
              </template>
            </v-data-table>
          </div>

          <div class="mt-4">
            <div class="caption font-weight-bold mb-2">Emergency Contact</div>
            <v-row>
              <v-col cols="12" sm="4" class="py-1">
                <v-text-field label="Name of person to contact" v-model="formData.emergencyContactName" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="py-1">
                <v-text-field label="Mob. No." v-model="formData.emergencyContactNo" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="py-1">
                <v-text-field label="Address" v-model="formData.emergencyContactAddress" outlined dense hide-details></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- 4. Educational Qualification -->
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card class="pa-6 rounded-xl" elevation="2">
          <div class="d-flex justify-space-between align-center mb-5 pb-2" style="border-bottom: 2px solid #e8f5e9;">
            <div class="d-flex align-center">
              <v-avatar color="#e8f5e9" size="40" class="mr-3">
                <v-icon color="#005f32">mdi-school</v-icon>
              </v-avatar>
              <div class="text-h6 font-weight-bold" style="color: #005f32;">4. Educational Qualification</div>
            </div>
            <v-btn small color="#005f32" dark @click="addEduRow" elevation="1">
              <v-icon left>mdi-plus</v-icon> Add Row
            </v-btn>
          </div>
          <v-data-table
            :headers="eduHeaders"
            :items="formData.educationalQualifications"
            hide-default-footer
            class="elevation-0"
            dense
          >
            <template v-slot:item.institution="{ item }">
              <v-text-field v-model="item.institution" dense hide-details></v-text-field>
            </template>
            <template v-slot:item.from="{ item }">
              <v-menu v-model="item.menuFrom" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="item.from" dense hide-details readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="item.from" no-title @input="item.menuFrom = false"></v-date-picker>
              </v-menu>
            </template>
            <template v-slot:item.to="{ item }">
              <v-menu v-model="item.menuTo" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="item.to" dense hide-details readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="item.to" no-title @input="item.menuTo = false"></v-date-picker>
              </v-menu>
            </template>
            <template v-slot:item.degree="{ item }">
              <v-text-field v-model="item.degree" dense hide-details></v-text-field>
            </template>
            <template v-slot:item.subject="{ item }">
              <v-text-field v-model="item.subject" dense hide-details></v-text-field>
            </template>
            <template v-slot:item.percentage="{ item }">
              <v-text-field v-model="item.percentage" dense hide-details></v-text-field>
            </template>
            <template v-slot:item.actions="{ item, index }">
              <v-icon color="red" @click="removeEduRow(index)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- 5. Employment Record -->
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card class="pa-6 rounded-xl" elevation="2">
          <div class="d-flex justify-space-between align-center mb-5 pb-2" style="border-bottom: 2px solid #e8f5e9;">
            <div class="d-flex align-center">
              <v-avatar color="#e8f5e9" size="40" class="mr-3">
                <v-icon color="#005f32">mdi-briefcase</v-icon>
              </v-avatar>
              <div class="text-h6 font-weight-bold" style="color: #005f32;">5. Employment Record</div>
            </div>
            <v-btn small color="#005f32" dark @click="addEmpRecordRow" elevation="1">
              <v-icon left>mdi-plus</v-icon> Add Row
            </v-btn>
          </div>
          <p class="caption">Starting with your most recent post, list in reverse order, positions held. Attach additional pages, if necessary.</p>
          <div style="overflow-x: auto;">
            <v-data-table
              :headers="empRecordHeaders"
              :items="formData.employmentRecords"
              hide-default-footer
              class="elevation-1 mt-3"
              dense
            >
              <template v-slot:item.employerNameAddress="{ item }">
                <v-textarea v-model="item.employerNameAddress" dense hide-details rows="2" class="pt-2 pb-2"></v-textarea>
              </template>
              <template v-slot:item.periodFrom="{ item }">
                <v-menu v-model="item.menuFrom" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="item.periodFrom" dense hide-details style="min-width: 130px;" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="item.periodFrom" no-title @input="item.menuFrom = false"></v-date-picker>
                </v-menu>
              </template>
              <template v-slot:item.periodTo="{ item }">
                <v-menu v-model="item.menuTo" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="item.periodTo" dense hide-details style="min-width: 130px;" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="item.periodTo" no-title @input="item.menuTo = false"></v-date-picker>
                </v-menu>
              </template>
              <template v-slot:item.designation="{ item }">
                <v-text-field v-model="item.designation" dense hide-details style="min-width: 120px;"></v-text-field>
              </template>
              <template v-slot:item.placeOfPosting="{ item }">
                <v-text-field v-model="item.placeOfPosting" dense hide-details style="min-width: 120px;"></v-text-field>
              </template>
              <template v-slot:item.salary="{ item }">
                <v-text-field v-model="item.salary" dense hide-details style="min-width: 100px;"></v-text-field>
              </template>
              <template v-slot:item.supervisorNameDesignation="{ item }">
                <v-textarea v-model="item.supervisorNameDesignation" dense hide-details rows="2" class="pt-2 pb-2"></v-textarea>
              </template>
              <template v-slot:item.dutiesDescription="{ item }">
                <v-textarea v-model="item.dutiesDescription" dense hide-details rows="2" class="pt-2 pb-2"></v-textarea>
              </template>
              <template v-slot:item.reasonForLeaving="{ item }">
                <v-text-field v-model="item.reasonForLeaving" dense hide-details style="min-width: 120px;"></v-text-field>
              </template>
              <template v-slot:item.actions="{ item, index }">
                <v-icon color="red" @click="removeEmpRecordRow(index)">mdi-delete</v-icon>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- 6. Publication / Papers -->
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card class="pa-6 rounded-xl" elevation="2">
          <div class="d-flex align-center mb-5 pb-2" style="border-bottom: 2px solid #e8f5e9;">
            <v-avatar color="#e8f5e9" size="40" class="mr-3">
              <v-icon color="#005f32">mdi-book-open-page-variant</v-icon>
            </v-avatar>
            <div class="text-h6 font-weight-bold" style="color: #005f32;">6. Publications / Papers (if applicable)</div>
          </div>
          <p class="caption">Mention your significant publications or papers in your professional field and names of journal etc, in which they appeared.</p>
          <v-textarea v-model="formData.publicationsPapers" outlined rows="3" hide-details></v-textarea>
        </v-card>
      </v-col>
    </v-row>

    <!-- 7. Language Proficiency -->
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card class="pa-6 rounded-xl" elevation="2">
          <div class="d-flex align-center mb-5 pb-2" style="border-bottom: 2px solid #e8f5e9;">
            <v-avatar color="#e8f5e9" size="40" class="mr-3">
              <v-icon color="#005f32">mdi-translate</v-icon>
            </v-avatar>
            <div class="text-h6 font-weight-bold" style="color: #005f32;">7. Language Proficiency</div>
          </div>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field label="1. Mother Tongue" v-model="formData.motherTongue" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <div class="d-flex justify-space-between align-center mt-4 mb-2">
            <div class="subtitle-2">2. Other Languages:</div>
            <v-btn small color="#005f32" dark @click="addLangRow">
              <v-icon left>mdi-plus</v-icon> Add Row
            </v-btn>
          </div>
          <v-data-table
            :headers="langHeaders"
            :items="formData.otherLanguages"
            hide-default-footer
            class="elevation-0"
            dense
          >
            <template v-slot:item.language="{ item }">
              <v-text-field v-model="item.language" dense hide-details></v-text-field>
            </template>
            <template v-slot:item.read="{ item }">
              <div class="d-flex justify-center">
                <v-checkbox v-model="item.read" hide-details class="mt-0 pt-0"></v-checkbox>
              </div>
            </template>
            <template v-slot:item.write="{ item }">
              <div class="d-flex justify-center">
                <v-checkbox v-model="item.write" hide-details class="mt-0 pt-0"></v-checkbox>
              </div>
            </template>
            <template v-slot:item.speak="{ item }">
              <div class="d-flex justify-center">
                <v-checkbox v-model="item.speak" hide-details class="mt-0 pt-0"></v-checkbox>
              </div>
            </template>
            <template v-slot:item.understand="{ item }">
              <div class="d-flex justify-center">
                <v-checkbox v-model="item.understand" hide-details class="mt-0 pt-0"></v-checkbox>
              </div>
            </template>
            <template v-slot:item.actions="{ item, index }">
              <v-icon color="red" @click="removeLangRow(index)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- 8. Extra Curricular Activities -->
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card class="pa-6 rounded-xl" elevation="2">
          <div class="d-flex align-center mb-5 pb-2" style="border-bottom: 2px solid #e8f5e9;">
            <v-avatar color="#e8f5e9" size="40" class="mr-3">
              <v-icon color="#005f32">mdi-star-face</v-icon>
            </v-avatar>
            <div class="text-h6 font-weight-bold" style="color: #005f32;">8. Extra Curricular Activities</div>
          </div>
          <v-row>
            <v-col cols="12" class="py-1">
              <v-textarea label="1. What are your hobbies?" v-model="formData.hobbies" outlined dense rows="2" hide-details></v-textarea>
            </v-col>
            <v-col cols="12" class="py-1">
              <v-textarea label="2. Have you ever been involved in any social work? If yes, give a brief on it." v-model="formData.socialWork" outlined dense rows="2" hide-details></v-textarea>
            </v-col>
            <v-col cols="12" class="py-1">
              <v-text-field label="3. Participation in sports/ games" v-model="formData.sportsParticipation" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" class="py-1">
              <v-textarea label="4. What are your special interests?" v-model="formData.specialInterests" outlined dense rows="2" hide-details></v-textarea>
            </v-col>
          </v-row>
          
          <div class="mt-6 pt-4 border-top">
            <v-checkbox v-model="isCertified" color="#005f32" hide-details class="mt-0 align-start">
              <template v-slot:label>
                <div class="caption text-justify" style="color: #333; line-height: 1.4;">
                  I certify that the statements made by me in this form are true, complete and correct. I understand that any false statement or required information, withheld by me, may provide grounds for the cancellation of the contract employment with the <strong>Wildlife Trust of India</strong>.
                </div>
              </template>
            </v-checkbox>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Global Save/Cancel -->
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <v-btn text class="mr-2 text-capitalize" @click="$router.push('/')">Cancel</v-btn>
        <v-btn color="#005f32" dark class="text-capitalize" large @click="saveProfile">Save Changes</v-btn>
      </v-col>
    </v-row>
    </v-form>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" right :timeout="snackbar.timeout">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "MyProfile",
  data() {
    return {
      rules: {
        email: value => !value || /.+@.+\..+/.test(value) || 'E-mail must be valid',
        phone: value => !value || /^\d{10}$/.test(value) || 'Must be 10 digits',
        pin: value => !value || /^\d{6}$/.test(value) || 'Must be 6 digits',
        pan: value => !value || /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/.test(value) || 'Invalid PAN format',
        aadhaar: value => !value || /^\d{12}$/.test(value) || 'Must be 12 digits',
        ifsc: value => !value || /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/.test(value) || 'Invalid IFSC code',
        accountNumber: value => !value || /^\d{9,18}$/.test(value) || 'Invalid account number',
        uan: value => !value || /^\d{12}$/.test(value) || 'Must be 12 digits',
      },
      isCertified: false,
      isDocUploading: false,
      menuDob: false,
      menuDom: false,
      snackbar: { show: false, message: "", color: "#005f32", timeout: 3000 },
      docUploadData: {
        title: "",
        file: null
      },
      sameAsMailing: false,
      formData: {
        title: "",
        photoPreview: null,
        photograph: null,
        firstName: "",
        lastName: "",
        fathersName: "",
        mothersName: "",
        dob: "",
        placeOfBirth: "",
        gender: "",
        bloodGroup: "",
        nationality: "",
        mobileNo: "",
        emailId: "",
        mailingAddress: "",
        mailingPin: "",
        permanentAddress: "",
        permanentPin: "",
        panCardNum: "",
        adharCardNum: "",
        passportNumber: "",
        drivingLicense: "",
        bankName: "",
        acNum: "",
        ifsc: "",
        epfUan: "",
        isNewEmployee: false,
        isExistingEmployee: true,
        esicCoverage: false,
        maritalStatus: "",
        dateOfMarriage: "",
        spouseName: "",
        spouseOccupation: "",
        spouseOrganization: "",
        children: [],
        emergencyContactName: "",
        emergencyContactNo: "",
        emergencyContactAddress: "",
        educationalQualifications: [
          { institution: "", from: "", to: "", degree: "", subject: "", percentage: "", menuFrom: false, menuTo: false }
        ],
        employmentRecords: [
          { employerNameAddress: "", periodFrom: "", periodTo: "", designation: "", placeOfPosting: "", salary: "", supervisorNameDesignation: "", dutiesDescription: "", reasonForLeaving: "", menuFrom: false, menuTo: false }
        ],
        publicationsPapers: "",
        motherTongue: "",
        otherLanguages: [
          { language: "", read: false, write: false, speak: false, understand: false }
        ],
        hobbies: "",
        socialWork: "",
        sportsParticipation: "",
        specialInterests: ""
      },
      childHeaders: [
        { text: "Name", value: "name" },
        { text: "Gender", value: "gender" },
        { text: "Age", value: "age" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      eduHeaders: [
        { text: "Institution/Board/University", value: "institution" },
        { text: "From", value: "from" },
        { text: "To", value: "to" },
        { text: "Certificate/Degree Obtained", value: "degree" },
        { text: "Main subject/field of study", value: "subject" },
        { text: "Percentage/Division/CGPA", value: "percentage" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      empRecordHeaders: [
        { text: "Name/ Address/ Tel No. of employer", value: "employerNameAddress", width: "200px" },
        { text: "From", value: "periodFrom" },
        { text: "To", value: "periodTo" },
        { text: "Exact Designation", value: "designation" },
        { text: "Place of posting", value: "placeOfPosting" },
        { text: "Salary/ month", value: "salary" },
        { text: "Name & Designation of Supervisor", value: "supervisorNameDesignation", width: "150px" },
        { text: "Brief description of duties and responsibilities", value: "dutiesDescription", width: "200px" },
        { text: "Reason for leaving", value: "reasonForLeaving" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      langHeaders: [
        { text: "Name of Language", value: "language" },
        { text: "Read", value: "read", align: 'center' },
        { text: "Write", value: "write", align: 'center' },
        { text: "Speak", value: "speak", align: 'center' },
        { text: "Understand", value: "understand", align: 'center' },
        { text: "Actions", value: "actions", sortable: false }
      ]
    };
  },
  watch: {
    sameAsMailing(val) {
      if (val) {
        this.formData.permanentAddress = this.formData.mailingAddress;
        this.formData.permanentPin = this.formData.mailingPin;
      }
    },
    'formData.mailingAddress'(val) {
      if (this.sameAsMailing) {
        this.formData.permanentAddress = val;
      }
    },
    'formData.mailingPin'(val) {
      if (this.sameAsMailing) {
        this.formData.permanentPin = val;
      }
    }
  },
  mounted() {
    this.getMyUploads();
  },
  methods: {
    showToast(message, color = "#005f32") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    getMyUploads() {
      const id = localStorage.getItem("userid");
      if (!id) return;
      axios({
        url: "/employee/document/view",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { id: id },
      })
      .then((response) => {
        if (response.data.status) {
          const mydocs = response.data.data;
          const doc = mydocs.documentDetails || {};
          const emp = mydocs.employeeDetails || {};

          // Employee Model details
          if (emp.photo && emp.photo !== "null" && emp.photo !== "undefined" && emp.photo !== "") {
            this.formData.photoPreview = this.mediaURL + emp.photo;
          } else {
            this.formData.photoPreview = null;
          }

          if (emp.name) {
            const nameParts = emp.name.split(" ");
            this.formData.firstName = nameParts[0] || "";
            this.formData.lastName = nameParts.slice(1).join(" ") || "";
          }
          this.formData.title = emp.title || doc.title || "";
          this.formData.dob = emp.dob ? emp.dob.substring(0, 10) : "";
          this.formData.gender = emp.gender || "";
          this.formData.mobileNo = emp.phonenumber || emp.mobileno || "";
          this.formData.emailId = emp.emailid || doc.personalEmail || "";
          
          // Document details
          this.formData.bloodGroup = doc.bloodGroup || "";
          this.formData.maritalStatus = doc.maritalStatus || "";
          this.formData.adharCardNum = doc.adharCardNum || "";
          this.formData.panCardNum = doc.panCardNum || "";
          this.formData.passportNumber = doc.passportNumber || doc.passportOrLicenceNum || "";
          this.formData.drivingLicense = doc.drivingLicense || "";
          this.formData.bankName = doc.bankName || "";
          this.formData.acNum = doc.acNum || "";
          this.formData.ifsc = doc.ifsc || "";

          // Newly added fields
          this.formData.fathersName = doc.fathersName || "";
          this.formData.mothersName = doc.mothersName || "";
          this.formData.placeOfBirth = doc.placeOfBirth || "";
          this.formData.nationality = doc.nationality || "";
          this.formData.dateOfMarriage = doc.dateOfMarriage ? doc.dateOfMarriage.substring(0, 10) : "";
          this.formData.spouseOccupation = doc.spouseOccupation || "";
          this.formData.spouseOrganization = doc.spouseOrganization || "";
          this.formData.publicationsPapers = doc.publicationsPapers || "";
          this.formData.motherTongue = doc.motherTongue || "";
          this.formData.hobbies = doc.hobbies || "";
          this.formData.socialWork = doc.socialWork || "";
          this.formData.sportsParticipation = doc.sportsParticipation || "";
          this.formData.specialInterests = doc.specialInterests || "";

          // Other missing fields from doc
          this.formData.epfUan = doc.epfUan || "";
          this.formData.esicCoverage = !!doc.esicCoverage;
          this.formData.spouseName = doc.spouseName || "";
          this.formData.emergencyContactName = doc.emergencyContactName || "";
          this.formData.emergencyContactNo = doc.emergencyContactNo || "";
          this.formData.emergencyContactAddress = doc.emergencyContactAddress || "";
          this.formData.mailingAddress = doc.mailingAddress || "";
          this.formData.mailingPin = doc.mailingPin || "";
          this.formData.permanentAddress = doc.permanentAddress || "";
          this.formData.permanentPin = doc.permanentPin || "";

          if (this.formData.permanentAddress && this.formData.permanentAddress === this.formData.mailingAddress && this.formData.permanentPin === this.formData.mailingPin) {
            this.sameAsMailing = true;
          }

          if (doc.otherLanguages && doc.otherLanguages.length > 0) {
            this.formData.otherLanguages = doc.otherLanguages;
          }
          if (doc.educationalQualifications && doc.educationalQualifications.length > 0) {
            this.formData.educationalQualifications = doc.educationalQualifications.map(e => ({
              ...e,
              from: e.fromDate ? e.fromDate.substring(0, 10) : "",
              to: e.toDate ? e.toDate.substring(0, 10) : "",
              subject: e.mainSubject,
              menuFrom: false,
              menuTo: false
            }));
          }
          if (doc.childrenProfile && doc.childrenProfile.length > 0) {
            this.formData.children = doc.childrenProfile;
          }
          if (doc.employmentRecords && doc.employmentRecords.length > 0) {
            this.formData.employmentRecords = doc.employmentRecords.map(e => ({
              ...e,
              periodFrom: e.periodFrom ? e.periodFrom.substring(0, 10) : "",
              periodTo: e.periodTo ? e.periodTo.substring(0, 10) : "",
              menuFrom: false,
              menuTo: false
            }));
          }
        }
      })
      .catch((err) => {
        console.error("Failed to load profile data", err);
      });
    },
    onImageSelected(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.photograph = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.photoPreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    addChildRow() {
      this.formData.children.push({ name: "", gender: "", age: "" });
    },
    removeChildRow(index) {
      this.formData.children.splice(index, 1);
    },
    addEduRow() {
      this.formData.educationalQualifications.push({ institution: "", from: "", to: "", degree: "", subject: "", percentage: "", menuFrom: false, menuTo: false });
    },
    removeEduRow(index) {
      this.formData.educationalQualifications.splice(index, 1);
    },
    addLangRow() {
      this.formData.otherLanguages.push({ language: "", read: false, write: false, speak: false, understand: false });
    },
    removeLangRow(index) {
      this.formData.otherLanguages.splice(index, 1);
    },
    addEmpRecordRow() {
      this.formData.employmentRecords.push({ employerNameAddress: "", periodFrom: "", periodTo: "", designation: "", placeOfPosting: "", salary: "", supervisorNameDesignation: "", dutiesDescription: "", reasonForLeaving: "", menuFrom: false, menuTo: false });
    },
    removeEmpRecordRow(index) {
      this.formData.employmentRecords.splice(index, 1);
    },
    async uploadEmployeeDocument() {
      if (!this.docUploadData.title || !this.docUploadData.file) {
        this.showToast("Please provide both document title and select a file.", "error");
        return;
      }
      
      const id = localStorage.getItem("userid");
      if (!id) return;

      const fd = new FormData();
      fd.append('docTitle', this.docUploadData.title);
      fd.append('documentUrl', this.docUploadData.file);
      
      this.isDocUploading = true;
      try {
        const res = await axios({
          url: `/employeedocs/upload/${id}`,
          method: 'POST',
          headers: {
            "x-auth-token": localStorage.getItem("token"),
            "Content-Type": "multipart/form-data"
          },
          data: fd
        });
        
        this.isDocUploading = false;
        if (res.data.status) {
          this.showToast("Document uploaded successfully!");
          this.docUploadData.title = "";
          this.docUploadData.file = null;
        } else {
          this.showToast("Upload failed: " + (res.data.msg || 'Unknown error'), "error");
        }
      } catch (err) {
        this.isDocUploading = false;
        console.error(err);
        this.showToast("An error occurred during upload.", "error");
      }
    },
    saveProfile() {
      if (this.$refs.profileForm && !this.$refs.profileForm.validate()) {
        this.showToast("Please fix the validation errors before saving.", "error");
        return;
      }

      if (!this.isCertified) {
        this.showToast("Please check the certification box before saving changes.", "error");
        return;
      }

      let fd = new FormData();
      fd.append("id", localStorage.getItem("userid"));
      
      if (this.formData.photograph) {
        fd.append("photo", this.formData.photograph);
      }
      
      // Also append other required fields for this endpoint so they aren't lost
      // Append standard fields
      fd.append("bloodGroup", this.formData.bloodGroup || "");
      fd.append("dob", this.formData.dob || "");
      fd.append("personalEmail", this.formData.emailId || "");
      fd.append("gender", this.formData.gender || "");
      fd.append("maritalStatus", this.formData.maritalStatus || "");
      
      // Append name, title and mobileNo
      fd.append("title", this.formData.title || "");
      fd.append("firstName", this.formData.firstName || "");
      fd.append("lastName", this.formData.lastName || "");
      fd.append("mobileNo", this.formData.mobileNo || "");
      
      // Append new text/date fields
      fd.append("fathersName", this.formData.fathersName || "");
      fd.append("mothersName", this.formData.mothersName || "");
      fd.append("placeOfBirth", this.formData.placeOfBirth || "");
      fd.append("nationality", this.formData.nationality || "");
      fd.append("dateOfMarriage", this.formData.dateOfMarriage || "");
      fd.append("spouseOccupation", this.formData.spouseOccupation || "");
      fd.append("spouseOrganization", this.formData.spouseOrganization || "");
      fd.append("publicationsPapers", this.formData.publicationsPapers || "");
      fd.append("motherTongue", this.formData.motherTongue || "");
      fd.append("hobbies", this.formData.hobbies || "");
      fd.append("socialWork", this.formData.socialWork || "");
      fd.append("sportsParticipation", this.formData.sportsParticipation || "");
      fd.append("specialInterests", this.formData.specialInterests || "");
      
      // Append other missing fields
      if (this.sameAsMailing) {
        this.formData.permanentAddress = this.formData.mailingAddress;
        this.formData.permanentPin = this.formData.mailingPin;
      }
      
      fd.append("epfUan", this.formData.epfUan || "");
      fd.append("esicCoverage", this.formData.esicCoverage);
      fd.append("spouseName", this.formData.spouseName || "");
      fd.append("emergencyContactName", this.formData.emergencyContactName || "");
      fd.append("emergencyContactNo", this.formData.emergencyContactNo || "");
      fd.append("emergencyContactAddress", this.formData.emergencyContactAddress || "");
      fd.append("mailingAddress", this.formData.mailingAddress || "");
      fd.append("mailingPin", this.formData.mailingPin || "");
      fd.append("permanentAddress", this.formData.permanentAddress || "");
      fd.append("permanentPin", this.formData.permanentPin || "");
      
      fd.append("panCardNum", this.formData.panCardNum || "");
      fd.append("adharCardNum", this.formData.adharCardNum || "");
      fd.append("passportNumber", this.formData.passportNumber || "");
      fd.append("drivingLicense", this.formData.drivingLicense || "");
      fd.append("bankName", this.formData.bankName || "");
      fd.append("acNum", this.formData.acNum || "");
      fd.append("ifsc", this.formData.ifsc || "");
      
      // Append complex array fields as JSON strings
      fd.append("educationalQualifications", JSON.stringify(this.formData.educationalQualifications));
      fd.append("employmentRecords", JSON.stringify(this.formData.employmentRecords));
      fd.append("otherLanguages", JSON.stringify(this.formData.otherLanguages));
      fd.append("childrenProfile", JSON.stringify(this.formData.children));

      axios({
        method: "POST",
        url: "/employee/personaldocument/upload",
        data: fd,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
      .then(response => {
        if (response.data.status) {
          this.showToast("Profile updated successfully!");
        } else {
          this.showToast("Failed to update profile: " + response.data.msg, "error");
        }
      })
      .catch(err => {
        console.error("Error updating profile", err);
        this.showToast("An error occurred while saving the profile.", "error");
      });
    }
  }
};
</script>

<style scoped>
.border-top {
  border-top: 1px solid #e0e0e0;
}
.h-100 {
  height: 100%;
}
</style>
